import React from "react";

import { Paragraph, Small } from "@fronterahealth/frontera-ui-components";

import { ReportTypeEnums } from "@api/graphql/types-and-hooks";

export type SelectableCardOptionType = {
  id: ReportTypeEnums;
  title: string;
  description: string;
  content?: React.ReactNode;
};

type SelectableCardListProps = {
  options: SelectableCardOptionType[];
  selectedOptionId: string | null;
  onSelect: (id: string) => void;
  name?: string;
};

const SelectableCardList: React.FC<SelectableCardListProps> = ({
  options,
  selectedOptionId,
  onSelect,
  name = "option",
}) => {
  return (
    <>
      {options.map((option) => (
        <div
          key={option.id}
          onClick={() => onSelect(option.id)}
          className={`flex items-center justify-between gap-4 p-4 mb-4 w-full bg-white rounded-lg border-2 border-solid cursor-pointer ${
            selectedOptionId === option.id ? "border-green-700" : "border-[#edeae7]"
          }`}
        >
          <div className="flex items-start gap-4 flex-1 flex-col">
            <div className="flex items-start w-full">
              <Small displayType="loud" colorType="primary">
                {option.title}
              </Small>
            </div>
            <div className="flex flex-col items-start w-full">
              <Paragraph colorType="primary">{option.description}</Paragraph>
            </div>
            {option.content !== undefined && (
              <div
                className={`transition-all w-full duration-500 ease-in-out ${
                  selectedOptionId === option.id
                    ? "max-h-96 opacity-100 mt-3 overflow-visible"
                    : "max-h-0 opacity-0 overflow-hidden"
                }`}
              >
                {option.content}
              </div>
            )}
          </div>

          <input
            type="radio"
            name={name}
            checked={selectedOptionId === option.id}
            onChange={() => onSelect(option.id)}
            onClick={(e) => e.stopPropagation()}
            className="h-5 w-5 appearance-none rounded-full border-2 border-gray-400 checked:border-green-700 checked:bg-green-700 focus:ring-2 focus:ring-green-700 focus:ring-offset-2 transition-colors duration-200"
          />
        </div>
      ))}
    </>
  );
};

export default SelectableCardList;
